/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";

export default function CampaignLayoutManageContent() {
  return (
    <div>
      <div>
        <h2 className="helpHeaderTitle">Manage Campaign </h2>
        <div className="helpContentSection">
          {" "}
          <div className="mb-3">
            <div className="boldTitle mt-2">Set Campaign Parameters (1)</div>
            <div>
              Campaign defaults to Full Screen Layout in Landscape ratio,
              orientation can be edited by clicking “1920 x 1080” dropdown and
              adjusting it to “1080 x 1920.” More screens can be added by
              pressing the “+” icon below Region 1.
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Preview Play (2)</div>
            <div>
              Click the “Play” button to see a preview of how the content will
              play within the campaign window (note: playlists do not currently
              display from this view, see the “Common Requests” section for how
              to send an external preview link where they will play.
            </div>
          </div>{" "}
          <div className="mb-3">
            <div className="boldTitle mt-2">Saving Campaign (3)</div>
            <div>
              Click “Save Campaign” to save a new campaign, “Update Campaign” to
              update an existing campaign, or “Update and Sync to Devices,” to
              update an existing campaign and have those changes sent to the
              screens it has been playing on.
            </div>
          </div>
          <img
            alt=""
            src={require("../../assets/images/helpCenter/campaignCenterImg3.png")}
          />{" "}
          <div>
            <div className="boldTitle mt-2">Further Options </div>
            <div>
              On the right side of the Campaign Tab Page, individual campaigns
              can be Viewed (this is where the preview link is found),
              duplicated, deleted, or archived.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
